import { Icon1C, IconBitrix24, IconMarket, IconMoySklad, IconOzon, IconWb, IconYml } from '@direct-frontend/components';
import { type OpenApiSchemaVariantExternalID } from '../../api/schema';

export const INTEGRATION_EXTERNAL_SYSTEM_ICONS: {
    icon: React.ReactNode;
    system_type: OpenApiSchemaVariantExternalID['system_type'];
}[] = [
    { icon: <IconWb key="wb" size="20" />, system_type: 'wildberries' },
    { icon: <IconMoySklad key="moysklad" size="20" />, system_type: 'moysklad' },
    { icon: <Icon1C key="1c" size="20" />, system_type: '1C' },
    { icon: <IconOzon key="ozon" size="20" />, system_type: 'ozon_sku' },
    { icon: <IconMarket key="yandex_market" size="20" />, system_type: 'yandex_market' },
    { icon: <IconYml key="yml" size="20" />, system_type: 'yml' },
    { icon: <IconBitrix24 key="bitrix" size="20" />, system_type: 'external_store' },
];
